import { Heart, Search, HandHeart, Share2, PawPrint, ArrowRight } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";
import { GraphicBackground } from "./GraphicBackground";

const steps = [
  { icon: Search, title: "Znajdź", color: "#4E8A6E" },
  { icon: Heart, title: "Sprawdź", color: "#3D7A5E" },
  { icon: HandHeart, title: "Pomóż", color: "#3D6B56" },
  { icon: Share2, title: "Udostępnij", color: "#5DADA0" },
];

interface Props {
  backgroundDataUrl?: string;
}

export const InstagramPost3Circles = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <GraphicBackground
      width={1080}
      height={1080}
      bgImage={bgImage}
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "100px",
        }}
      >
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: "64px" }}>
          <h1
            style={{
              fontSize: "80px",
              fontWeight: 800,
              color: "#2D5A3D",
              margin: "0",
              lineHeight: 1.1,
            }}
          >
            Jak pomóc<br />zwierzakom?
          </h1>
        </div>

        {/* Circles row */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          {steps.map((s, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              {/* Circle */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "16px",
                }}
              >
                <div
                  style={{
                    width: "160px",
                    height: "160px",
                    background: `linear-gradient(135deg, ${s.color} 0%, ${s.color}CC 100%)`,
                    borderRadius: "50%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: `0 12px 40px ${s.color}50`,
                  }}
                >
                  <span style={{ fontSize: "48px", fontWeight: 800, color: "#FFFFFF", lineHeight: 1 }}>
                    {i + 1}
                  </span>
                  <s.icon style={{ width: "36px", height: "36px", color: "rgba(255,255,255,0.9)", marginTop: "4px" }} />
                </div>
                <span style={{ fontSize: "24px", fontWeight: 700, color: "#2D5A3D" }}>
                  {s.title}
                </span>
              </div>

              {/* Arrow between circles */}
              {i < 3 && (
                <ArrowRight style={{ width: "28px", height: "28px", color: "#9CB8A8", marginBottom: "40px" }} />
              )}
            </div>
          ))}
        </div>

        {/* Subtitle */}
        <p
          style={{
            fontSize: "32px",
            fontWeight: 600,
            color: "#4A7A5E",
            margin: "56px 0 0 0",
            textAlign: "center",
          }}
        >
          Każdy krok ma znaczenie 💚
        </p>

        {/* Logo */}
        <div
          style={{
            marginTop: "56px",
            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <div
            style={{
              background: "#4E8A6E",
              borderRadius: "14px",
              width: "56px",
              height: "56px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            }}
          >
            <PawPrint style={{ width: "32px", height: "32px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "36px", fontWeight: 800, color: "#2D5A3D" }}>
            GdzieSchronisko
          </span>
        </div>
      </div>
    </GraphicBackground>
  );
};

